export class Constants {
  public static get TemplateBaseUrl(): string {
    return "/templates";
  }
}
